import "./MainImageCropper.scss"
import {useRef, useState} from "react";
import ReactCrop, {centerCrop, convertToPixelCrop, makeAspectCrop} from 'react-image-crop'
import {SnackbarHelper} from "../../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../../context/SnackBarContext";
import thumbnailPic from "../img/selfie.svg"
import 'react-image-crop/dist/ReactCrop.css'
import {RaikoButtonPrimary, RaikoButtonSecondary, RaikoGridOneColumn} from "@moeindal/base-raiko-panel-components";


export default function MainImageCropper(
    {
        updateAvatar,
        ASPECT_RATIO = 1,
        thumbnail = thumbnailPic,
        primaryButtonTitle = "برش تصویر",
        secondaryButtonTitle = "انتخاب تصویر",
    }) {
    const MIN_DIMENSION = 100;

    const imgRef = useRef(null);
    const previewCanvasRef = useRef(null);
    const [imgSrc, setImgSrc] = useState("")
    const [crop, setCrop] = useState(null)
    const [error, setError] = useState("")
    const snackBarHelper = new SnackbarHelper(useSnackbarDispatcher())

    const onSelectFile = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();
        reader.addEventListener("load", () => {
            const imageElement = new Image();
            const imageUrl = reader.result?.toString() || "";
            imageElement.src = imageUrl;
            imageElement.addEventListener("load", (e) => {
                if (error) setError("");
                const {naturalWidth, naturalHeight} = e.currentTarget;
                if (naturalWidth < MIN_DIMENSION || naturalHeight < MIN_DIMENSION) {
                    setError("ابعاد تصویر مورد نظر باید حداقل 100*100 پیکسل باشد");
                    return setImgSrc("");
                }
            })
            setImgSrc(imageUrl)
        });
        reader.readAsDataURL(file)
        handleFile(file)
    }
    const onImageLoad = (e) => {
        const {width, height} = e.currentTarget;
        const cropWidthInPercent = (MIN_DIMENSION / width) * 100;
        const crop = makeAspectCrop(
            {
                unit: "%",
                width: cropWidthInPercent,
            },
            ASPECT_RATIO,
            width,
            height
        );
        const centeredCrop = centerCrop(crop, width, height)
        setCrop(centeredCrop)
    }
    //uploader-image-code-started
    const [fileName, setFileName] = useState("");
    const handleFile = (file) => {
        setFileName(file.name);
    };
    const hiddenFileInput = useRef(null);
    const handleOpenSelectImageDialog = (event) => {
        hiddenFileInput.current.click();
    };


    return (
        <RaikoGridOneColumn>
            <div className="mainImageCropperLayout">
                <div className={"ImageCropperContent"}>
                    <input
                        ref={hiddenFileInput}
                        type="file"
                        onChange={onSelectFile}
                        accept="image/*"
                        style={{display: "none"}}
                    />
                </div>
                {error && snackBarHelper.showWarningMessage(error)}
                {imgSrc && imgSrc ? <div className={"mainImageCropperContainer"}>
                    <ReactCrop
                        crop={crop}
                        onChange={(pixelCrop, percentCrop) => setCrop(percentCrop)}
                        circularCrop={false}
                        keepSelection={true}
                        aspect={ASPECT_RATIO}
                        minWidth={MIN_DIMENSION}

                    >
                        <img
                            ref={imgRef}
                            className="mainImageCropperContent"
                            src={imgSrc}
                            alt="upload"
                            onLoad={onImageLoad}
                        />
                    </ReactCrop>
                </div> : <div className="primaryImage" onClick={handleOpenSelectImageDialog}>
                    <img src={thumbnail} alt="thumbnail"/>
                    <span>برای انتخاب عکس مورد نظر کلیک کنید!</span>
                </div>
                }
                {imgSrc && imgSrc ? <div className="imageCropperFooter">
                    <RaikoButtonSecondary
                        label={secondaryButtonTitle}
                        onClick={handleOpenSelectImageDialog}
                    />
                    <RaikoButtonPrimary
                        label={primaryButtonTitle}
                        onClick={() => {
                            setCanvasPreview(
                                imgRef.current,
                                previewCanvasRef.current,
                                convertToPixelCrop(
                                    crop,
                                    imgRef.current.width,
                                    imgRef.current.height
                                ),
                            );
                            const dataUrl = previewCanvasRef.current.toDataURL();
                            updateAvatar(dataUrl, fileName);
                        }}
                    />
                </div> : null}
                {
                    crop &&
                    <canvas
                        ref={previewCanvasRef}
                        className={"canvasMainStyle"}

                    />
                }
            </div>


        </RaikoGridOneColumn>
    )
}
const setCanvasPreview = (
    image,
    canvas,
    crop,
) => {
    const ctx = canvas.getContext("2d")
    if (!ctx) {
        throw new Error("No 2d context")
    }
    const pixelRatio = window.devicePixelRatio;
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    canvas.width = Math.floor(crop.width * scaleX * pixelRatio);
    canvas.height = Math.floor(crop.height * scaleY * pixelRatio);

    ctx.scale(pixelRatio, pixelRatio);
    ctx.imageSmoothingQuality = "high";
    ctx.save();

    const cropX = crop.x * scaleX;
    const cropY = crop.y * scaleY;

    ctx.translate(-cropX, -cropY);
    ctx.drawImage(
        image,
        0,
        0,
        image.naturalWidth,
        image.naturalHeight,
        0,
        0,
        image.naturalWidth,
        image.naturalHeight,
    );
    ctx.restore();
};
